/* eslint-disable */

import { toCurrency } from '../../utils/CurrencyUtil'
import ActionPlanPlanCards from './ActionPlanPlanCards'
import ActionPlanBottomBar from './ActionPlanBottomBar'

const Plans = ({
  adminPlans,
  totalLumpsum,
  totalSip,
  isAllSelected,
  setIsAllSelected,
  selectedPlans,
  openPlans,
  handleCheckboxChange,
  togglePlan,
  onOpen,
  isDesktop,
  flowStep,
  sipDate,
  sipDates,
  selectedDay,
  setSelectedDay,
  mandatesState,
  mandates,
  disableButtons,
  mandateRegistration,
  generateOTP,
  loading,
  setMessageModalState,
  openOTPPopup,
  setOpenOTPPopup,
  userDetails,
  email,
  handleSipOrOT,
}) => {


  return (
    <div className='md:max-w-[760px] lg:max-w-[1128px] mx-4 md:mx-auto mt-2'>
      <div>
        <h1 className='flex justify-between items-center mt-4'>
          <span className='font-DMSans font-semibold text-lg md:text-xl text-black-500'>
            Your Plans ({adminPlans?.length})
          </span>
        </h1>
        <p className='font-DMSans md:text-lg text-sm font-normal text-black-400'>
          Plans have been curated as per your needs
        </p>
      </div>

      <div className='flex flex-col lg:flex-row gap-4 my-4'>
        <div className='py-2 px-3 md:p-5 bg-primary-50 rounded-[7px] flex-1'>
          <h1 className='font-DMSans font-medium md:text-base text-[14px] text-[#4C4C4C] leading-[26px]'>
            One time Investment
          </h1>
          <p className='font-normal md:mt-3 text-2xl md:text-3xl text-primary-600 h-[36px] flex items-end leading-none'>
            <span className='font-DMSans md:text-[1.6rem] font-extrabold mr-2 flex items-end'>
              ₹
            </span>
            <span className='font-OrelegaOne md:text-[28px] tracking-[4%]'>
              {toCurrency(totalLumpsum)}
            </span>
          </p>
        </div>

        <div className='p-3 md:p-5 bg-primary-50 rounded-[7px] flex-1'>
          <h1 className='font-DMSans font-medium md:text-base text-[14px] text-[#4C4C4C] leading-[26px]'>
            SIP (Excluding active SIPs)
          </h1>
          <p className='font-normal md:mt-3 text-2xl md:text-3xl text-primary-600 h-[36px] flex items-end leading-none'>
            <span className='font-DMSans md:text-[1.6rem] font-extrabold mr-2 flex items-end'>
              ₹
            </span>
            <span className='font-OrelegaOne md:text-[28px] tracking-[4%]'>
              {toCurrency(totalSip)}
            </span>
          </p>
        </div>
      </div>

      <div className='mb-2 flex justify-between'>
        <p>Select a plan to proceed</p>
        <span
          className={`font-DMSans font-medium text-sm ${isAllSelected ? 'text-black-300' : 'text-primary-600'
            } cursor-pointer`}
          onClick={() => setIsAllSelected(!isAllSelected)}
        >
          {isAllSelected ? 'Deselect All' : 'Select All'}
        </span>
      </div>

      <ActionPlanPlanCards
        adminPlans={adminPlans}
        selectedPlans={selectedPlans}
        openPlans={openPlans}
        handleCheckboxChange={handleCheckboxChange}
        togglePlan={togglePlan}
        onOpen={onOpen}
        isDesktop={isDesktop}
      />

      <ActionPlanBottomBar
        flowStep={flowStep}
        sipDate={sipDate}
        sipDates={sipDates}
        selectedDay={selectedDay}
        setSelectedDay={setSelectedDay}
        mandatesState={mandatesState}
        mandates={mandates}
        disableButtons={disableButtons}
        mandateRegistration={mandateRegistration}
        generateOTP={generateOTP}
        loading={loading}
        setMessageModalState={setMessageModalState}
        openOTPPopup={openOTPPopup}
        setOpenOTPPopup={setOpenOTPPopup}
        userDetails={userDetails}
        email={email}
        handleSipOrOT={handleSipOrOT}
      />
    </div>
  )
}

export default Plans
